import Component from 'gia/Component'
import _each from 'lodash.foreach'
import Flickity from 'flickity'

class Slider extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      slider: null,
      next: null,
      prev: null
    }

  }

  mount() {


    var flkty = new Flickity(this.ref.slider, {
    
     // cellAlign: 'left',
      wrapAround: true,
      //contain: true,
      pageDots: false,
      prevNextButtons: false

    });

    this.ref.prev.addEventListener('click', (e)=>{
      e.preventDefault()
      flkty.previous()
    })
    this.ref.next.addEventListener('click', (e)=>{
      e.preventDefault()
      flkty.next()
    })

    
}




  unmount() {




  }


}

module.exports = Slider
